import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Telescope, List } from 'lucide-react';
import { cn } from '@/components/ui/utils';

const tabs = [
  { label: 'All Prospects', href: '/prospects', icon: List, exact: true },
];

export function ProspectsLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (href: string, exact?: boolean) => {
    if (exact) return location.pathname === href;
    return location.pathname.startsWith(href);
  };

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <div className="border-b px-4 lg:px-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 py-3">
            <Telescope className="h-5 w-5 text-muted-foreground" />
            <div>
              <span className="text-sm font-semibold">Prospects</span>
              <span className="text-xs text-muted-foreground ml-2">Pre-pipeline brand intelligence</span>
            </div>
          </div>
          <nav className="flex gap-1 -mb-px">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const active = isActive(tab.href, tab.exact);
              return (
                <button
                  key={tab.href}
                  onClick={() => navigate(tab.href)}
                  className={cn(
                    'flex items-center gap-1.5 px-3 py-3 text-sm font-medium border-b-2 transition-colors',
                    active
                      ? 'border-foreground text-foreground'
                      : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                  )}
                >
                  <Icon className="h-4 w-4" />
                  {tab.label}
                </button>
              );
            })}
          </nav>
        </div>
      </div>
      <div className="flex flex-1 flex-col overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
}
